import { DenominationMode } from '@/../client-generator/generated-clients/plants';

const toLabel = (
  index: number,
  denominationMode: DenominationMode | undefined,
  maxCount: number = 0
) => {
  return denominationMode == DenominationMode.Letters
    ? convertIndexToLetters(index)
    : index.toString().padStart(maxCount, '0');
};

function convertIndexToLetters(index: number): string {
  if (index == 0) return '';

  const div = Math.floor((index - 1) / 26);
  const mod = (index - 1) % 26;
  const Letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return convertIndexToLetters(div) + Letters[mod];
}

export { toLabel };
